// Tracks how many times the quiz has been taken, using Web Storage
const ATTEMPTS_KEY = "total_attempts";

export function getAttempts(): number {
  return Number(localStorage.getItem(ATTEMPTS_KEY)) || 0;
}

export function incrementAttempts(): number {
  const attempts = getAttempts() + 1;
  localStorage.setItem(ATTEMPTS_KEY, String(attempts));
  return attempts;
}
